import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";

export default function LabTabShell({
  record,
  register,
  registerCount,
  correctionCount = 0,
  testId = "lab-inner-tabs",
}) {
  return (
    <Tabs defaultValue="record" className="w-full" data-testid={testId}>
      <TabsList className="bg-card border border-border p-1 h-auto flex-wrap mb-4">
        <TabsTrigger value="record" className="text-xs sm:text-sm">
          Record
          {correctionCount > 0 ? (
            <span className="ml-1.5 rounded-full bg-amber-100 text-amber-900 px-1.5 py-0.5 text-[10px] font-medium">
              {correctionCount} fix
            </span>
          ) : null}
        </TabsTrigger>
        <TabsTrigger value="register" className="text-xs sm:text-sm">
          Register ({registerCount ?? 0})
          {correctionCount > 0 ? (
            <span className="ml-1.5 rounded-full bg-amber-100 text-amber-900 px-1.5 py-0.5 text-[10px] font-medium">
              {correctionCount}
            </span>
          ) : null}
        </TabsTrigger>
      </TabsList>
      <TabsContent value="record" className="mt-0 space-y-6">
        {record}
      </TabsContent>
      <TabsContent value="register" className="mt-0">
        {register}
      </TabsContent>
    </Tabs>
  );
}
